import http from "../../utils/http"

/**
 * รับรายการประกาศ
 */
export function noticesList(params) {
    return http({
        url: "/api/notice/page",
        data: params
    })
}
/**
 * รับรายละเอียดการประกาศ
 */
export function noticeDetail(params) {
    return http({
        url: "/api/notice/info",
        data: params
    })
}
